import { render, staticRenderFns } from "./edit.videos.page.vue?vue&type=template&id=43851d31&"
import script from "./edit.videos.page.vue?vue&type=script&lang=js&"
export * from "./edit.videos.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports